import Vue from 'vue/dist/vue.min.js';
import EventBus from './event-bus';
import store from './store';

export const template = {
    data: function () {
        return {
            activeTab: '',
            isMobile: null
        }
    },
    methods: {
        setActiveTab(e) {
            this.activeTab = e;
        },
        handleTab(e) {
            let tabTarget = e.currentTarget.dataset.target;

            if (tabTarget !== this.activeTab) {
                // console.log("derp");
                this.setActiveTab(tabTarget);
                this.$el.querySelector('.hiw__tab-item.active').classList.remove('active');

                this.$el.querySelector(`[data-target=${tabTarget}]`).classList.add('active');
            }
        },
        setResponsive(mql) {
            this.isMobile = mql.matches ? true : false;
            if (!this.isMobile) {
                // remove inline styles from accordions
                let accordionContainers = this.$el.querySelectorAll('.hiw__hiw-content-container');
                accordionContainers.forEach((item) => {
                    item.style = null;
                });
            }
        },
        // set the first tab to active
        initDesktop() {
            // this is checking for a breakpoint *smaller* than
            // var isMobile in store.js
            var mql = window.matchMedia('(max-width: 650px)');
            this.isMobile = mql.matches ? true : false;

            mql.addEventListener('change', () => {
                this.setResponsive(mql);
            });


            if (this.isMobile) { //under 650px
                let initial = this.$el.querySelector('[data-target]') ? this.$el.querySelector('[data-target]').dataset.target : null;
                this.activeTab = initial;
            } else { //over 650px
                // if desktop, check for desktop buttons and set initial tab
                let initial = this.$el.querySelector('[data-target]') ? this.$el.querySelector('[data-target]').dataset.target : null;
                this.activeTab = initial;
                if (this.$el.querySelector('[data-target]')) {
                    this.$el.querySelector('[data-target]').classList.add('active');
                }
            }
        }
    },
    mounted() {
        this.initDesktop(); //set the first tab to active on init
        //listen for child click events on the labels and pass targets to parent
        EventBus.$on('handle-mobile', (e) => {
            this.setActiveTab(e);
        })
        EventBus.$on('handle-desktop', (e) => {
            this.setActiveTab(e);
        })
    }
};

export const tabLabel = {
    props: ['activeTab', 'isMobile'],
    data: function () {
        return {
            tabTarget: '',
            isActive: false,
            index: null,
            label: null
        }
    },
    computed: {
        taggingMeta: function () {
            return JSON.stringify({
                "type": "layer",
                "category": "Drawer",
                "action": "Open",
                "label": this.label,
                "no": this.index < 10 ? `0${this.index}` : `${this.index}`
            });
        }
    },
    watch: {
        activeTab: function () {
            this.isActive = this.activeTab == this.tabTarget ? true : false;
        }
    },
    methods: {
        handleTab(e) {
            EventBus.$emit('handle-desktop', this.tabTarget);
        },
        init() {
            this.label = this.$el.innerHTML;
            console.log(`tabLabel INIT this.label = ${this.label}`);
            this.index = Array.prototype.slice.call(document.querySelectorAll('.hiw__tab-labels li')).indexOf(this.$el) + 1;
        },
    },
    mounted() {
        this.tabTarget = this.$el.dataset.target;
        this.init();
    }
};

export const contentTemplate = {
    props: ['activeTab', 'isMobile'], //active tab
    data: function () {
        return {
            tabName: '',
            isActive: false, //is current tab the selected tab 'activeTab'
            isOpen: false, //is tab openm
            label: null,
            index: null
        }
    },
    computed: {
        taggingMeta: function () {
            return JSON.stringify({
                "type": "layer",
                "category": "Drawer",
                "action": "Open",
                "label": this.label,
                "no": this.index < 10 ? `0${this.index}` : `${this.index}`
            });
        }
    },
    watch: {
        activeTab: function (tab) {
            this.isActive = this.tabName == tab ? true : false;
        },
        isActive: function () {
            if (!this.isActive) {
                this.isOpen = false; //set accodion to close when not the active item

                // close the accordion
                if (this.isMobile) {

                    let contentArea = this.$el.querySelector('.hiw__hiw-content-container');
                    let contentHeight = this.$el.querySelector('.hiw__hiw-content-inner').getBoundingClientRect().height;

                    requestAnimationFrame(function () {
                        //set content area height to content height to prevent transitioning from auto
                        contentArea.style.maxHeight = contentHeight + 'px';
                        // have the element transition to height: 0
                        requestAnimationFrame(function () {
                            contentArea.style.maxHeight = '0px';
                        });
                    });

                    contentArea.addEventListener('transitionend', () => {
                        contentArea.style.maxHeight = '0';
                    });

                    this.scrollToTop();
                }
            } else {
                // if this is the active tab, set isOpen to true when isActive is true to pre open the tab on mobile
                this.isOpen = true;
            }
        }
    },
    methods: {
        handleMobile(e) {
            let mobileTarget = e.currentTarget.parentNode.dataset.tabId;

            EventBus.$emit('handle-mobile', mobileTarget);

            if (this.isMobile) {
                // toggle the accordion
                this.handleAccordion(e);
            }
        },
        scrollToTop() {
            let elmOffset = this.$el.offsetTop;
            let scrollOffset = window.scrollY;
            if (elmOffset < scrollOffset) {
                let elmPos = this.$el.getBoundingClientRect().top + window.scrollY;
                setTimeout(function () {
                    window.scrollTo({
                        top: (elmPos - 70),
                        behavior: 'smooth'
                    });
                }, 500);
            }
        },
        // toggle accordions
        handleAccordion(e) {
            let contentArea = this.$el.querySelector('.hiw__hiw-content-container');
            let contentHeight = this.$el.querySelector('.hiw__hiw-content-inner').getBoundingClientRect().height;

            if (this.isOpen == true) {
                this.isOpen = false;

                requestAnimationFrame(function () {
                    //set content area height to content height to prevent transitioning from auto
                    contentArea.style.maxHeight = contentHeight + 'px';
                    // have the element transition to height: 0
                    requestAnimationFrame(function () {
                        contentArea.style.maxHeight = '0px';
                    });
                });

                contentArea.addEventListener('transitionend', () => {
                    contentArea.style.maxHeight = '0';
                });

            } else {
                this.isOpen = true;
                contentArea.style.maxHeight = contentHeight + "px";
                contentArea.addEventListener('transitionend', () => {
                    contentArea.style.maxHeight = 'none';
                });
            }
        },

        initMobile() {
            if (this.isMobile) {
                // console.log("is mobile");
            } else {
                // console.log("not mobile");

                // remove all inline styles for accordions on desktop
                let contentContainers = this.$el.querySelectorAll('.hiw__hiw-content-container');
                contentContainers.forEach((item) => {
                    item.style = ''
                });
            }
        },
        init() {
            this.index = Array.prototype.slice.call(document.querySelectorAll('.hiw__area-content .hiw__hiw-container')).indexOf(this.$el) + 1;
            this.label = Array.prototype.slice.call(document.querySelectorAll('.hiw__tab-labels li'))[(this.index - 1)].innerHTML;
            console.log(`CONTENTTEMPLATE INIT this.label = ${this.label}`);
        }
    },
    mounted() {
        var initialTab = this.$el.dataset.tabId;
        this.tabName = initialTab;
        this.initMobile();
        this.init();
    }
};


const HowItWorks = () => {
    const instances = document.querySelectorAll('.hiw__wrapper');

    let hiwConstructor = (id) => {
        // main component wrapper
        Vue.component('hiw-template', template);

        // desktop labels
        Vue.component('hiw-tab-label', tabLabel);

        // mobile accordion containers & labels
        Vue.component('hiw-content-template', contentTemplate);

        new Vue({
            el: `.hiw-${id}`,
            store: store
        }).$mount(`.hiw-${id}`, true);
    }

    if (instances.length > 0) {
        instances.forEach((item, index) => {
            item.classList.add(`hiw-${index}`);
            hiwConstructor(index);
        })
    }
}

export default HowItWorks;
